import partnerClient from "../partnerClient";

const unwrap = (data) => data?.data ?? data;

export const fetchSupportTickets = async (params) =>
  unwrap((await partnerClient.get("/support-tickets", { params })).data);

export const openSupportTicket = async (formData) =>
  unwrap((await partnerClient.post("/support-tickets", formData)).data);

export const fetchSupportTicket = async (ticketId) =>
  unwrap((await partnerClient.get(`/support-tickets/${ticketId}`)).data);

export const fetchSupportTicketEntries = async (ticketId, params) =>
  unwrap((await partnerClient.get(`/support-tickets/${ticketId}/entries`, { params })).data);

export const replyToSupportTicket = async (ticketId, formData) =>
  unwrap((await partnerClient.post(`/support-tickets/${ticketId}/entries`, formData)).data);

export const changeSupportTicketStatus = async (ticketId, payload) =>
  unwrap((await partnerClient.post(`/support-tickets/${ticketId}/status`, payload)).data);

export const markSupportTicketRead = async (ticketId) =>
  unwrap((await partnerClient.post(`/support-tickets/${ticketId}/read`)).data);

export const fetchSupportUnreadCount = async () =>
  unwrap((await partnerClient.get("/support-tickets/unread-count")).data);

/** The shape SupportTicketThread takes, so the page does not wire each call by hand. */
export const partnerTicketApi = {
  fetchDetail: fetchSupportTicket,
  fetchEntries: fetchSupportTicketEntries,
  reply: replyToSupportTicket,
  changeStatus: changeSupportTicketStatus,
  markRead: markSupportTicketRead,
};
